<template>
    <div>
        <v-container fluid grid-list-md>
            <v-layout row>
                <v-flex xs12 sm7 md9 d-flex>
                    <v-layout column>
                        <h3>{{ $t('Dashboard.News') }}</h3>
                        <article class="article" v-for="(article, index) in news" :key="`news-${article.ID}`">
                            <div style="padding: 16px 16px 0"><h4>{{ article.name }}</h4></div>
                            <div style="padding: 0 16px">
                                <span>{{ new Date(article.creationdate * 1000).toLocaleDateString(
                                    $i18n.locale, {
                                      day: '2-digit',
                                      month: '2-digit',
                                      year: 'numeric',
                                    })
                                  }}</span>
                                {{ article.description }}
                            </div>
                            <div v-html="article.body" style="overflow-y: scroll; padding: 16px"></div>
                        </article>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm5 md3 d-flex>
                    <v-layout column class="support">
                        <h3>{{ $t('Dashboard.Support') }}</h3>
                        <v-flex xs12 v-for="(support, index) in supports" :key="`support-${support.ID}`" class="support">
                            <sec-img v-if="support.image" :src="getImageUrl(support.ID)" class="profile-picture"></sec-img>
                            <h4 class="silver">{{support.name}}</h4>
                            <div v-if="support.position"><h4>{{support.position}}</h4></div>
                            <div><a v-if="support.email" :href="`mailto:${support.email}`" class="silver">{{support.email}}</a></div>
                            <div><a v-if="support.phone" :href="`tel:${support.phone}`" class="silver">{{support.phone}}</a></div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  export default {
    name: 'Dashboard',
    data() {
      return {
        supports: [],
        news: [],
      }
    },
    async mounted() {
      this.supports = await this.fetchSupportService();
      this.news = await this.fetchNews();
      this.$forceUpdate();
    },
    methods: {
      getImageUrl(ID) {
        return this.$root.route(`dashboard/customerservice/${ID}/image`)
      },
      async fetchSupportService() {
        const url = this.$root.route('dashboard/customerservice');
        const {data} = await this.$http.get(url);
        console.log('supports', data);

        return [...data.result.data];
      },
      async fetchNews() {
        const url = this.$root.route('dashboard/news');
        const {data} = await this.$http.get(url);
        console.log('news', data);

        return [...data.result.data];
      }
    }
  }
</script>

<style>
    .article {
        margin-top: 16px;
        background: white;
    }

    .profile-picture {
        max-width: 50%;
        max-height: 10vh;
        background-image: linear-gradient(90deg, #33a6e4, #acca6e);
        padding: 3px;
        border-radius: 50%;
    }

    .support {
        text-align: center;
        margin-top: 16px;
    }

    .support > h4 {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .silver {
        color: gray;
    }
</style>
